import { useEffect, useState } from 'react';
import { api } from '../axios.service';
import { ResponseApi } from '../../types/response/responseapi.model';
import { MailRequest } from '../../types/request/mail.model';
import { NewForgetPasswordRequest } from '../../types/request/newforgetpassword.model';

export function useForgetPassword(mail : MailRequest | null | undefined){
    const [data, setData] = useState<ResponseApi>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        if (mail) {
            setIsLoading(true);
            api.post<MailRequest>("/forgetpassword", mail)
                .then(res => setData(res.data as ResponseApi))
                .catch(err => {setError(err)})
                .finally(() => setIsLoading(false));
        }
    }, [mail]);

    return {data, isLoading, error };
}

export function useNewForgetPassword(passwordRequest : NewForgetPasswordRequest | null | undefined){
    const [data, setData] = useState<ResponseApi>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        if (passwordRequest) {
            setIsLoading(true);
            api.post<MailRequest>("/newforgetpassword", passwordRequest)
                .then(res => setData(res.data as ResponseApi))
                .catch(err => {setError(err)})
                .finally(() => setIsLoading(false));
        }
    }, [passwordRequest]);

    return {data, isLoading, error };
}
